<template>
	<div>		
		<div v-if="!error && confirmDetails && apiAvailable" class="alert alert-custom-none" role="alert">
			<span class="icon icon-check mr-2"></span>Information found for {{domain}}
		</div>

		<div v-if="!error && confirmDetails && !apiAvailable" class="alert alert-custom-high" role="alert">
			<span class="icon icon-circle-with-cross mr-2"></span>Company Data API currently unavailable. PLease enter details manually.
		</div>

		<div v-if="!error && notFound" class="alert alert-custom-high" role="alert">
			<span class="icon icon-circle-with-cross mr-2"></span>No information found for {{domain}}
		</div>

		<error :error="error"></error>

		<div class="form-row" v-if="!confirmDetails && !notFound">
			<div class="col-sm-6">
				<div class="m-t form-group required">
					<label class="control-label required" for="domain-input">Domain</label>
					<input id="domain-input" class="form-control" :class="{'is-invalid':domainError.length}" placeholder="company.com" v-model="domain"/>
					<div class="invalid-feedback" v-if="domainError">{{domainError}}</div>
				</div>			
			</div>
			<div class="col-sm-6">

			</div>
		</div>

		<form id="add-domain-form" novalidate class="needs-validation" :class="{'was-validated':hasError}" v-on:submit.prevent="saveForm">

			<!-- User has to enter more details manually -->
			<div v-if="notFound" class="mt-4">
				<p>
					Please provide accurate information for this domain. Employee totals can usually be found using Google.<br>
					Select an industry based on the <a href="https://en.wikipedia.org/wiki/Global_Industry_Classification_Standard" target="_blank">Global Industry Classification Standard</a>.
				</p>
				<div class="form-row mt-4">
					<div class="col-sm-6">
						<div class="m-t form-group required">
							<label class="control-label required" for="user-total-input">Employees</label>
							<input id="user-total-input" class="form-control" :class="{'is-invalid':totalError.length}" @change="userTotalChange" maxlength="8" size="8" placeholder="" v-model="userTotal"/>
							<div class="invalid-feedback" v-if="totalError">{{totalError}}</div>
						</div>
						<div class="m-t form-group required">
							<label class="control-label required" for="industry-select">Industry</label>
							<select id="industry-select" class="form-control custom-select" :class="{'is-invalid':industryError.length}" @change="industryChange" v-model="industry">
								<option v-for="option in industryOptions" :value="option[0]" :key="option[0]">{{option[1]}}</option>
							</select>
							<div class="invalid-feedback" v-if="industryError">{{industryError}}</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Display the details found for the company -->
			<div v-if="confirmDetails" class="mt-4">
				<div class="form-row">
					<div class="col-sm-12">
						<div class="m-t form-group required">
							<label class="control-label required" for="name-confirm">Name</label>
							<input id="name-confirm" class="form-control display-only" v-model="companyDetails.name" readonly/>
						</div>
					</div>
				</div>
				<div class="form-row" v-if="companyDetails.description">
					<div class="col-sm-12">
						<div class="m-t form-group required">
							<label class="control-label required" for="description-confirm">Description</label>
							<textarea id="description-confirm" class="form-control display-only" rows="3" v-model="companyDetails.description" readonly/>
						</div>
					</div>
				</div>
				<div class="form-row" v-if="companyDetails.location">
					<div class="col-sm-12">
						<div class="m-t form-group required">
							<label class="control-label required" for="location-confirm">Location</label>
							<input id="location-confirm" class="form-control display-only" v-model="companyDetails.location" readonly/>
						</div>
					</div>
				</div>
				<div class="form-row">
					<div class="col-sm-6">
						<div class="m-t form-group required" v-if="companyDetails.categorySector">
							<label class="control-label required" for="industry-confirm">Industry</label>
							<input id="industry-confirm" class="form-control display-only" v-model="companyDetails.categorySector" readonly/>
						</div>

						<div class="m-t form-group required" v-else>
							<label class="control-label required" for="industry-confirm-select">Industry</label>
							<select id="industry-confirm-select" class="form-control custom-select" :class="{'is-invalid':industryError.length}" @change="industryChange" v-model="industry">
								<option v-for="option in industryOptions" :value="option[0]" :key="option[0]">{{option[1]}}</option>
							</select>
							<div class="invalid-feedback" v-if="industryError">{{industryError}}</div>
						</div>
					</div>
				</div>
				<div class="form-row">
					<div class="col-sm-6">
						<div class="m-t form-group required" v-if="companyDetails.metricsEmployees">
							<label class="control-label required" for="employees-confirm">Employees</label>
							<input id="employees-confirm" class="form-control display-only" v-model="employeesDescription" readonly/>
						</div>

						<div class="m-t form-group required" v-else>
							<label class="control-label required" for="employees-confirm-input">Employees</label>
							<input id="employees-confirm-input" class="form-control" :class="{'is-invalid':totalError.length}" maxlength="8" size="8" placeholder="" v-model="userTotal"/>
							<div class="invalid-feedback" v-if="totalError">{{totalError}}</div>
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-sm-6">
				</div>
				<div class="col-sm-6">
					<div class="text-right" v-if="!(notFound || confirmDetails)">		
						<button type="button" class="btn btn-outline-primary px-3" @click="formNext">Next</button>						
						<button type="button" class="btn btn-outline-primary px-3" @click="closeForm">Cancel</button>	
					</div>
					<div class="text-right" v-if="notFound || confirmDetails">
						<button type="submit" class="btn btn-outline-primary px-3">Add</button>						
						<button type="button" class="btn btn-outline-primary px-3" @click="closeForm">Cancel</button>						
					</div>

				</div>
			</div>

		</form>
	</div>
</template>

<script>
	import Error from './Error'
	
	import api from '../api'
	import store from '../state'
	import router from '../router'

	export default {
		name: 'AddDomainForm',
		components: {Error},
		data() {
			return {
				domain: '',
				industry: 0,
				userTotal:'',
				error: null,
				domainError:'',
				totalError:'',
				industryError:'',
				notFound: false,
				confirmDetails: false,
				apiAvailable: true,
				companyDetails: {},
				industryOptions: [
					["15","Materials"],
					["20","Industrials"],
					["10","Energy"],
					["25","Consumer Discretionary"],
					["30","Consumer Staples"],
					["35","Health Care"],
					["40","Financials"],
					["45","Information Technology"],
					["50","Telecommunication Services"],
					["55","Utilities"],
					["60","Real Estate"]
				]
			}
		},
		methods: {
			industryChange() {
				this.industryError = '';
			},
			userTotalChange() {
				if (this.userTotal && this.isNumeric(this.userTotal) && this.userTotal > 0) this.totalError = "";
			},
			closeForm() {
				this.clear();
				this.$emit('close-add-domain');
			},
			async formNext() {
				this.error = '';
				this.totalError = '';
				this.domainError = '';
				this.notFound = false;
				this.confirmDetails = false;

				if (!this.domain) this.domainError = 'Please enter a valid domain';		
				if (this.domain.startsWith('www.')) this.domainError = 'Please enter a domain without the www. prefix';		

				//Check if we have already added this domain
				const existing = store.getters.getDomain(this.domain);
				if (existing) this.domainError = 'This domain has already been added';

				if (this.hasError) return;

				//Lookup company data
				var response = await api.get(`domain/company/${this.domain}`);	

				//If we have any record at all, then set confirmDetails to true.
				//User may still have to enter critical data
				if (response.data.statusCode == "OK")
				{
					this.confirmDetails = true;
					this.apiAvailable = true;
					this.companyDetails = response.data;
				}
				else if (response.data.statusCode == "PaymentRequired")
				{
					this.confirmDetails = true;
					this.apiAvailable = false;
				}
				else if (response.data.statusCode == "NotFound")
				{
					this.notFound = true;
				}
				//e.g. status code 422
				else {
					this.domainError = "Domain does not appear to be valid."
				}

			},
			async saveForm() {
				
				//Do any validation
				this.industryError = '';
				this.totalError = '';		
				
				try
				{
					var payload = {value:this.domain};

					//Workout if we need to include industry and total, and from which control
					if (this.confirmDetails) {
						if (!this.companyDetails.categorySector) {
							if (!this.industry) this.industryError = "Please select an industry value";
							payload.industry = parseInt(this.industry);
						}

						if (!this.companyDetails.metricsEmployees) {
							if (!this.userTotal || !this.isNumeric(this.userTotal) || this.userTotal < 1) this.totalError = 'Please enter valid number of employees';
							payload.total = parseInt(this.userTotal);	
						} 
					}

					if (this.notFound) {
						if (!this.industry) this.industryError = "Please select an industry value";
						if (!this.userTotal || !this.isNumeric(this.userTotal) || this.userTotal < 1) this.totalError = 'Please enter valid number of employees';

						payload.industry = parseInt(this.industry);
						payload.total = parseInt(this.userTotal);
					}

					if (this.industryError || this.totalError) return;
						
					var response = await api.post('domain', payload);	

					store.dispatch('getDomainsAsync');
					this.closeForm();
				}
				catch(err) {
					this.error = err;
				}
			},
			isNumeric(value) {
				return /^\d+$/.test(value);
			},
			clear() {
				this.domain = '';
				this.industry = 10;
				this.userTotal = '';
				this.domainError = '';
				this.totalError = '';
			}
		},
		computed: {
			hasError() {
				return (!!this.domainError || !!this.totalError);
			},
			employeesDescription() {
				if (!this.companyDetails) return '';
				if (!this.companyDetails.metricsEmployeesRange) return this.companyDetails.metricsEmployees;
				return (`${this.companyDetails.metricsEmployees} (${this.companyDetails.metricsEmployeesRange})`)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/AddDomainForm.vue